import React, {Component} from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '../../../components/button';

class DdlPreviewPanel extends Component {
  handleCopy = () => {
    const {ddl, direction} = this.props;
    // eslint-disable-next-line security/detect-object-injection -- direction is one of two known literals AtoB|BtoA
    const script = ddl && ddl[direction] && ddl[direction].script ? ddl[direction].script : '';
    navigator.clipboard.writeText(script);
  };

  render() {
    const {ddl, direction, onDirectionChange, canCopy} = this.props;
    // eslint-disable-next-line security/detect-object-injection -- direction is one of two known literals AtoB|BtoA
    const script = (ddl && ddl[direction] && ddl[direction].script) ? ddl[direction].script : '';

    return (
      <div className="sc-ddl-panel" data-testid="sc-ddl-panel">
        <RadioGroup
          row
          value={direction}
          onChange={(e) => onDirectionChange(e.target.value)}
          data-testid="sc-ddl-direction"
        >
          <FormControlLabel value="AtoB" control={<Radio />} label="Make TARGET match SOURCE" />
          <FormControlLabel value="BtoA" control={<Radio />} label="Make SOURCE match TARGET" />
        </RadioGroup>
        {canCopy && (
          <Button label="Copy full script" data-testid="sc-ddl-copy" onClick={this.handleCopy} />
        )}
        <pre className="sc-ddl-content" data-testid="sc-ddl-content">{script || '(no DDL generated)'}</pre>
      </div>
    );
  }
}

export default DdlPreviewPanel;
